export type StartupMilestone =
  | 'loader-visible'
  | 'bootstrap-requested'
  | 'ui-rendered'
  | 'map-ready'
  | 'manifest-ready'
  | 'data-ready'
  | 'interactive';

type PerformanceMarker = Pick<Performance, 'mark'>;
type FrameScheduler = (callback: FrameRequestCallback) => number;

export function markStartup(
  milestone: StartupMilestone,
  marker: PerformanceMarker = globalThis.performance,
): void {
  try {
    marker.mark(`quillay:${milestone}`);
  } catch {
    return;
  }
}

export function waitForInitialPaint(
  schedule: FrameScheduler = globalThis.requestAnimationFrame.bind(globalThis),
): Promise<void> {
  return new Promise((resolve) => {
    schedule(() => resolve());
  });
}
